import React from 'react';
import { AppBar, Box, Button, CircularProgress, Toolbar } from '@mui/material';
import { Save as SaveIcon, Cancel as CancelIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

// Sticky bottom submit/cancel bar shown only on mobile (md and below).
// Pair with a `<Box sx={{ pb: { xs: 10, md: 0 } }}>` on the form so content
// doesn't tuck under the footer.
//
// Props:
//   onSubmit:     submit handler (omit when wrapped in a form with type=submit)
//   submitType:   'submit' (default) or 'button'
//   onCancel:     cancel handler (function) OR
//   cancelTo:     RouterLink `to`
//   isSubmitting: shows spinner + disables submit
//   saveLabel:    'Save' (default)
//   cancelLabel:  'Cancel' (default)
//   saveDisabled: extra disable condition
const MobileFormFooter = ({
  onSubmit,
  submitType = 'submit',
  onCancel,
  cancelTo,
  isSubmitting = false,
  saveLabel = 'Save',
  cancelLabel = 'Cancel',
  saveDisabled = false,
}) => {
  const cancelProps = cancelTo
    ? { component: RouterLink, to: cancelTo }
    : { onClick: onCancel };

  return (
    <AppBar
      position="fixed"
      color="default"
      elevation={3}
      sx={{
        display: { xs: 'block', md: 'none' },
        top: 'auto',
        bottom: 0,
        pb: 'env(safe-area-inset-bottom)',
      }}
    >
      <Toolbar sx={{ gap: 1, justifyContent: 'space-between' }}>
        <Button
          variant="outlined"
          color="inherit"
          startIcon={<CancelIcon />}
          {...cancelProps}
        >
          {cancelLabel}
        </Button>
        <Button
          type={submitType}
          onClick={submitType === 'submit' ? undefined : onSubmit}
          variant="contained"
          color="primary"
          startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
          disabled={isSubmitting || saveDisabled}
          sx={{ flex: 1, ml: 1 }}
        >
          {isSubmitting ? 'Saving…' : saveLabel}
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default MobileFormFooter;
